import { dateDb } from '@/utils/filters';
import moment from 'moment';
import pager from '../includes/pager';

const startDate = moment()
  .subtract(1, 'month')
  .startOf('month');

export const state = {
  pager: {
    ...pager.state.pager,
    filter: {
      adDeliveryMonth: dateDb(startDate)
    }
  },
  jobBatch: null
};

const mutations = {
  ...pager.mutations,
  setJobBatch(state, batch) {
    state.jobBatch = batch;
  }
};

const actions = {
  ...pager.actions
};

const getters = {
  ...pager.getters,
  getJobBatch: state => state.jobBatch
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
